// extracted by mini-css-extract-plugin
export default {"groupContent":"ContentGroups_groupContent--bzt","groupContainer":"ContentGroups_groupContainer--Ji5"};